export default "__VITE_ASSET__i$ZEkmsb__"